import $ from 'jquery';

window.jQuery = $;
window.$ = $;
window.Swal = require('sweetalert2');
window.intlTelInput = require('intl-tel-input');

import 'jquery-ui/ui/widgets/sortable.js';
import 'jquery-ui/ui/widgets/autocomplete.js';
import select2 from 'select2';
import datepicker from 'bootstrap-datepicker';
import daterangepicker from 'daterangepicker';
import { initial, isEmpty, isNull, result } from 'lodash';
import c from './asset/pace/pace.min';

require('./global_variables');
require('./asset/laravel_filemanager/stand-alone-button');
require('./asset/summernote/summernote-bs4.min');
require('./asset/bootstrap/bootstrap.bundle.min');
require('./asset/adminlte/adminlte');
require('./asset/intl_tel_input/utils');
require('./asset/pace/pace.min');

// import intlTelInput from 'intl-tel-input';
// import Swal from 'sweetalert2';
const UFG = window.UFG = { 'name': '' };
UFG.name = 'adminjs'
UFG.siteUrl = document.location.origin;
UFG.currentUrl = window.location.pathname;
UFG.loadingHtml = '<div class="p-3 loading-div"><div class="col-12 rounded p-2 mb-2 animated-background"></div><div class="col-8 rounded p-2 animated-background"></div></div>';
UFG.siteLogo = UFG.siteUrl + '/images/logos/TravelWhiteLogo.svg';




jQuery(function ($) {


    UFG.show_alert = function (icon, message) {
        Toast.fire({
            icon: icon,
            title: message
        })
    }


    UFG.url_params = function () {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            // vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    $(document).on('change', 'input', '.start-time', function () {
        let $startDateField = $(this);
        let startDate = $startDateField.val();

        if (startDate === '') {
            $startDateField.val('');
        }

    });


    $(document).on('change', '.end-time', function () {

        let $endDateField = $(this);
        let endDate = $endDateField.val();

        if (endDate === '') {
            $endDateField.val('');
        }

    });

    $(document).on('change', '.getCountryToLocation', function () {

        var supplier_country_ids = $(this).val();
        var url = `${BASEURL}country-on-change`;
        let options = '';
        console.log(supplier_country_ids);
        if (supplier_country_ids.length > 0) {

            $.ajax({
                type: 'get',
                url: url,
                data: { 'supplier_country_ids': supplier_country_ids },
                beforeSend: function () {
                    $('.appendCountryLocation').html(options);
                },
                success: function (locations) {

                    options = locations.map(location => `<option data-value="${location.name}" value="${location.id}" >${location.name} (${location.country_name})</option>`).join("");

                    $('.appendCountryLocation').html(options);
                }
            });
        }
    });

    $(document).on('click', '.dyn-list-btn', function (e) {
        e.preventDefault();
        let $this = $(this),
            parentPage = $this.parents('.dyn-wrapper'),
            dynList = $this.parents('.dyn-list'),
            url = $this.data('action'),
            module = dynList.data('module'),
            modal = parentPage.find('.dyn-modal');
        console.log(modal);
        $.ajax({
            type: "GET",
            url: url,
            data: { module: module },
            beforeSend: function () {
                $this.find('i').removeClass('fa-plus').addClass('spinner-border').css({ width: '8px', height: '10px' });
                $this.attr('disabled', true);
            },
            success: function (resp) {

                if (resp.html) {
                    $this.find('i').removeClass('spinner-border').addClass('fa-plus')
                    $this.attr('disabled', false);
                    modal.modal('show');
                    modal.find('.dyn-title').text(module);
                    modal.find('.dyn-content').html(resp.html)

                    if (modal.find('.select2single').length) {
                        reinitializedSingleSelect2()
                    }
                    if (modal.find('.select2-multiple').length) {
                        reinitializedMultipleSelect2();
                    }

                }


            },

        });
    });

    $(document).on('submit', '.dyn-create-form', function (e) {
        e.preventDefault();
        let $this = $(this),
            parentPage = $this.parents('.dyn-wrapper'),
            url = $this.attr('action'),
            modal = parentPage.find('.dyn-modal'),
            module = $this.find('.dyn-save-btn').attr('module');
        // parentID = parentPage.find(`div[data-module="${module}"]`).data('pid');
        // formData = new FormData(this);
        // if(parentID) formData.append("parent_id",parentID);
        $.ajax({
            type: "POST",
            url: url,
            data: new FormData(this),
            contentType: false,
            cache: false,
            processData: false,
            beforeSend: function () {
                removeFormValidationStyles();
                // addFormLoadingStyles();
            },
            success: function (resp) {
                console.log(resp.id);

                // removeModalFormLoadingStyles(`#${formID}`);
                modal.modal('hide');


                Toast.fire({
                    icon: 'success',
                    title: resp.message
                });

                if (resp) {

                    let dropDown = parentPage.find(`div[data-module="${module}"]`).find('.dyn-list-drop');
                    let extraAttr = '';
                    if (resp.action) {
                        extraAttr = `data-action=${resp.action}`;
                    } else if (resp.currency_id) {
                        extraAttr = `data-currency-id=${resp.currency_id}`;
                    }
                    // let optHtml = `<option ${extra} value="${resp.id}">${resp.name}</option>`;
                    dropDown.append(`<option ${extraAttr} value="${resp.id}">${resp.name}</option>`);

                    dropDown.val(resp.id).trigger('change');

                }
            },
            error: function (data) {
                printServerValidationErrors(data);
            },
            complete: function () {
                // removeFormLoadingStyles();
            }
        })


    });


    // var fileManagerKey;

    // window.addEventListener('filemanager.select', function (e) {

    //     let fieldSelector = $(`.img-selector`),
    //         link = fieldSelector.val(),
    //         anchor = fieldSelector.parents('.form-group').find('.img-prev-link')
    //     anchor.attr("href", link).html("(Preview)");
    // });

    // $(document).on('click', '.img-upload-btn', function () {
    //     fileMananagerQuoteKey = $(this).data('key');
    // });


    $(document).on('click', '.simple-file-manager-image-preview-link', function (event) {

        event.preventDefault();

        let href = $(this).attr('href');

        Swal.fire({
            // title: 'Sweet!',
            // text: 'Modal with a custom image.',
            imageUrl: href,
            imageWidth: 500,
            imageHeight: 300,
            // imageAlt: 'Custom image',
        })

    });

    $(document).on("click", ".infolink", function (e) {
        // console.log('click popover')
        // console.log(e.target)
        // $('[data-toggle="popover"]').popover();
        $(e.target).popover('show');
    });
    // $('.popover-dismiss').popover({
    //     trigger: 'focus'
    // })

    let usFMOptions = {
        // prefix: window.location.origin + '/ufg-form/public/laravel-filemanager'
        prefix: FILE_MANAGER_URL
    }
    $('.lfm_image').filemanager('image', usFMOptions);
    $('.lfm_file').filemanager('file', usFMOptions);

    // image show and hide on click button
    $('.toggle-bar-image').click(() => $('.open_sidebar, .close_sidebar').toggleClass('d-none'));

    // after click the button the image hover
    $('.toggle-bar-image').click(function () {
        if (!$('body').hasClass('sidebar-collapse')) {
            $('.main-sidebar').on('mouseenter', function () {
                if ($('.open_sidebar').hasClass('d-none')) {
                    $('.close_sidebar').addClass('d-none');
                    $('.open_sidebar').removeClass('d-none');
                }
            }).on('mouseleave', function () {
                if ($('.close_sidebar').hasClass('d-none')) {
                    $('.open_sidebar').addClass('d-none');
                    $('.close_sidebar').removeClass('d-none');
                }
            });
        } else {
            $('.main-sidebar').off('mouseenter').off('mouseleave');
        }
    });
    // set autofocus on search
    $(document).on('select2:open', '.select2single, .selling-price-other-currency', function (e) {

        $(".select2-search__field").each(function (key, value) {
            value.focus({
                preventScroll: true
            });
        });
    });

    $(document).on("select2:select", '.select2-multiple', function (e) {
        let parentDiv = $(this).parents('form-group');
        var data = e.params.data.id;
        if (data == 'all') {
            $("#" + $(this).attr('id') + " > option").prop("selected", "selected").trigger('change');
            $("#" + $(this).attr('id') + " > option[value=all]").prop("selected", false);
            $("#" + $(this).attr('id')).trigger("change");
        }
        // console.log($(this).val());
        // if(data = 'all-days'){

        // }
    });


    window.dateGreater = function (date1 = false, date2 = false) {
        if (!date1 || !date2) return false;

        date1 = new Date(convertDate(date1));
        date2 = new Date(convertDate(date2));

        return (date1 > date2);
    }

    window.Toast = Swal.mixin({
        toast: true,
        icon: 'success',
        position: 'top-right',
        showConfirmButton: false,
        timer: 2200,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    window.log = function (message) {
        console.log(message);
    }

    jQuery.fn.ForceNumericOnly = function () {
        return this.each(function () {
            $(this).keydown(function (e) {
                var key = e.charCode || e.keyCode || 0;
                // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
                // home, end, period, and numpad decimal
                return (key == 8 || key == 9 || key == 13 || key == 46 || key == 110 || key == 190 || (key >= 35 && key <= 40) || (key >= 48 && key <= 57) || (key >= 96 && key <= 105));
            });
        });
    };

    window.calltextEditorSummerNote = function (val = null) {

        $('.summernote:last').summernote('destroy');
        $('.note-editor:last').remove();
        $('.summernote').summernote({
            height: 100,   //set editable area's height
            placeholder: 'Enter Text Here..', codemirror: { // codemirror options
                theme: 'monokai'
            }
        }, 'code', val);
    }


    window.setTextEditorValue = function (id, Text) {
        $(id).summernote('code', Text);
    }

    window.formatState = function (option) {
        var optionImage = $(option.element).attr('data-image');
        if (!optionImage) {
            return option.text;
        }

        return $(`<span><img height="19" width="19" src="${optionImage}" class="option-flag-image" />${option.text}</span>`);
    };

    window.reinitializedSingleSelect2 = function (width = '100%') {

        $('.select2single').select2({
            width: width, theme: 'bootstrap', templateResult: formatState, templateSelection: formatState,
        });
    }

    window.reinitializedMultipleSelect2 = function (sl2mClass = false) {
        // console.log(sl2mClass)
        if (sl2mClass) {
            $('#' + sl2mClass).select2({
                width: '100%', theme: "classic", templateResult: formatState, templateSelection: formatState,
                allowClear: true,
                templateSelection: function (data, container) {
                    $(container).addClass('opt-inactive');
                    return data.text;
                }
            });
        } else {
            $('.select2-multiple').select2({
                width: '100%', theme: "classic", templateResult: formatState, templateSelection: formatState,
                allowClear: true,
                templateSelection: function (data, container) {
                    $(container).addClass('opt-inactive');
                    return data.text;
                }
            });
        }
    }

    window.destroySingleSelect2 = function () {
        if ($('.select2single').data('select2')) {
            $('.select2single').select2('destroy');
        }
    }

    window.destroyMultipleSelect2 = function () {
        if ($('.select2-multiple').data('select2')) {
            $('.select2-multiple').select2('destroy');
        }
    }

    window.disabledFeild = function (p) {
        $(p).attr("disabled", true);
    }

    window.removeDisabledAttribute = function (p) {
        $(p).removeAttr("disabled");
    }

    window.removeSpace = function (string) {
        return string.replace(/\s/g, '');
    }

    /*
    |--------------------------------------------------------------------------
    | Define Global Functions
    |--------------------------------------------------------------------------
    */

    window.removeFormValidationStyles = function () {
        $('input, select, textarea').removeClass('is-invalid');
        $('.invalid-feedback').html("");
    }

    window.resetModalForm = function (modalID) {
        window.resetForm(`#${modalID}`);
        $(`${modalID} .summernote`).summernote("reset");
        $(`${modalID} input, select, textarea`).removeClass('is-invalid');
        $(`${modalID} .invalid-feedback`).html('');
    }

    window.addFormLoadingStyles = function () {
        $("#overlay").addClass('overlay');
        $(".note-editor").css('border-color', '');
        $("#overlay").html(`<i class="fas fa-2x fa-sync-alt fa-spin"></i>`);
    }

    window.addModalFormLoadingStyles = function (formSelector) {

        $(`${formSelector} button[type="submit"]`).find('span').addClass('spinner-border spinner-border-sm');
    }

    window.removeModalFormLoadingStyles = function (formSelector) {

        setTimeout(function () {

            $(`${formSelector} button[type="submit"]`).find('span').removeClass('spinner-border spinner-border-sm');
        }, 250);
    }

    window.removeFormLoadingStyles = function () {
        setTimeout(function () {
            $("#overlay").removeClass('overlay');
            $("#overlay").html('');
        }, 250);
    }


    // Used in Quote & Booking
    window.stickyValidationErrors = function (response) {

        if (response.status === 422) {

            let errors = response.responseJSON;

            if ((Object.keys(errors).length) > 0) {
                $('#sticky_button').removeClass('d-none');
            }
        }
    }

    window.sumArrayValues = function (arrayClass) {

        let amount = $(arrayClass).map((i, event) => parseFloat(removeComma(event.value))).get();

        amount = amount.reduce((a, b) => (a + b), 0);

        return amount;
    };


    $(document).on('click', '#sticky_button', function () {

        event.preventDefault();

        let url = $(this).closest("form").attr('action');
        let formID = $(this).closest("form").attr('id');

        $.ajax({
            type: 'POST',
            url: url,
            data: new FormData($(`#${formID}`)[0]),
            contentType: false,
            cache: false,
            processData: false,
            beforeSend: function () {
                removeFormValidationStyles();
            },
            success: function (response) {
                printServerSuccessMessage(response, `#${formID}`);
            },
            error: function (response) {
                removeFormLoadingStyles();
                printServerValidationErrors(response);
            }
        });
    });


    //- Used in Quote & Booking
    window.printServerSuccessMessage = function (response, formSelector = null) {
        if (formSelector !== undefined) {
            // window.resetForm(formSelector);
        }

        let message = response;
        if (response.hasOwnProperty('message')) {
            message = response.message;
        }

        let icon = response.status === false ? 'error' : 'success';
        Toast.fire({
            icon: icon, title: message
        });


        if (response.hasOwnProperty('redirect_url')) {
            setTimeout(function () {
                window.location.href = response.redirect_url;
            }, redirectTime);
        }

        if (response.hasOwnProperty('content_url')) {
            $("#listing_card_body").load(`${response.content_url} #listing_card_body`);
        }
    }

    window.printServerErrorMessage = function (response) {
        let message = response;
        if (response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
            message = response.responseJSON.message;
        }

        Toast.fire({
            icon: 'error', title: message
        });
    }

    /** Show Alert After Page Load */
    let sessionSuccess = $('#success_session'),
        sessionFail = $('#fail_session'),
        sessionInfo = $('#info_session');

    window.showAlert = function (icon, text) {
        Toast.fire({
            icon: icon,
            text: text
        });
    };
    // Session Messages
    if (sessionSuccess.data('session') !== "") showAlert('success', sessionSuccess.data('message'));
    if (sessionFail.data('session') !== "") showAlert('error', sessionFail.data('message'));
    if (sessionInfo.data('session') !== "") showAlert('info', sessionInfo.data('message'));
    /** Show Alert After Page Load */


    window.printServerValidationErrors = function (response) {

        if (response.status === 422) {

            let errors = response.responseJSON,
                flag = true,
                bookingDetailChildSection = "finance";

            setTimeout(function () {
                console.log(errors.errors);
                jQuery.each(errors.errors, function (index, value) {
                    // console.log(index, value)
                    index = index.replace(/\./g, '_');

                    console.log(index);
                    // console.log(index.includes(bookingDetailChildSection));

                    /* Expand Quote Details Card */

                    let closestQuote = $(`#${index}`).closest('.quote');
                    // console.log(closestQuote)
                    closestQuote.removeClass('collapsed-card');
                    closestQuote.children('.card-body').css("display", "block");
                    closestQuote.children('.collapse-expand-btn').html(`<i class="fas fa-minus"></i>`);

                    if (index.includes(bookingDetailChildSection)) {
                        closestQuote.find('.payment-section').removeClass('collapsed-card');
                        closestQuote.find('.card-body').css("display", "block");
                        closestQuote.find('.collapse-expand-btn').html(`<i class="fas fa-minus"></i>`);
                    }

                    /* --------------------------------  */

                    $(`#${index}`).addClass('is-invalid');
                    $(`#${index}`).closest('.form-group').find('.invalid-feedback').html(value);
                    $(`#${index}`).closest('.form-group').find('.note-editor').css('border-color', 'red');

                    if (flag) {
                        if ($(`#${index}`).parents('.form-group').length) {
                            $('html, body').animate({ scrollTop: $(`#${index}`).parents('.form-group').offset().top }, 1000);
                            flag = false;
                        }
                    }
                });

            }, 250);

        }
    }


    window.printListingSuccessMessage = function (response) {

        let icon = response.status === false ? 'error' : 'success';
        Toast.fire({
            icon: icon, title: response.message
        });

        setTimeout(function () {
            location.reload();
        }, 2500);



        // $("#listing_card_body").load(`${location.href} #listing_card_body`);

        // let icon = response.status === false ? 'error' : 'success';
        // Toast.fire({ icon: icon, title: response.message });

    }

    window.printListingErrorMessage = function (response) {

        Toast.fire({
            icon: 'error', title: response.hasOwnProperty('responseJSON') ? response.responseJSON.message : response
        });
    }

    window.validateSameCurrencies = function (currencyArray) {

        let unique = currencyArray.filter((v, i, a) => a.indexOf(v) === i);

        if (unique.length === 1) {
            return true;
        }

        return false;
    }
    window.SuccessMessageReloadPage = function (response, modalSelector) {


        Toast.fire({
            icon: 'success', title: response.message
        });

        setTimeout(function () {
            location.reload();
        }, 2500);
    }


    window.printModalServerSuccessMessage = function (response, modalSelector) {

        // if (response && response.status) {

        $(`${modalSelector}`).modal('hide');

        $("#listing_card_body").load(`${location.href} #listing_card_body`);

        Toast.fire({
            icon: 'success', title: response.message
        });

        /* Reload page if you are on edit page */
        if (!CURRENT_ROUTE_NAME.includes('index')) {
            setTimeout(function () {
                location.reload();
            }, 2500);
        }
        // }
    }

    window.printModalServerValidationErrors = function (response, modalSelector) {
        if (response.status === 422) {

            let errors = response.responseJSON;
            let flag = true;

            setTimeout(function () {
                jQuery.each(errors.errors, function (index, value) {

                    index = index.replace(/\./g, '_');

                    $(`${modalSelector} #${index}`).addClass('is-invalid');
                    $(`${modalSelector} #${index}`).closest('.form-group').find('.invalid-feedback').html(value);
                });

            }, 250);

        }
    }

    window.printAlertResponse = function (response) {

        if (response && response.status) {

            $("#listing_card_body").load(`${location.href} #listing_card_body`);

            Toast.fire({
                icon: 'success', title: response.success_message
            });

            /* Reload page if you are on edit page */
            if (!CURRENT_ROUTE_NAME.includes('index')) {
                setTimeout(function () {
                    location.reload();
                }, 2500);
            }
        }

        if (response && !response.status) {

            Toast.fire({
                icon: 'error', title: response.error_message
            });
        }
    }

    window.printServerAlertResponse = function (response) {

        if (response && response.status) {

            Toast.fire({
                icon: 'success', title: response.success_message
            });

            setTimeout(function () {
                location.reload();
            }, 2500);
        }
    }

    window.curday = function (sp) {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //As January is 0.
        var yyyy = today.getFullYear();
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        return (yyyy + sp + mm + sp + dd);
    };

    window.todayDate = function () {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        return today = dd + '/' + mm + '/' + yyyy;
    }

    window.convertDate = function (date) {
        var dateParts = date.split("/");
        return dateParts = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    }

    window.slashFormatDate = function (date) {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        return today = dd + '/' + mm + '/' + yyyy;
    }

    $(document).on('keyup', "input[data-type='currency']", function (e) {
        formatCurrency($(this));
    });

    $(document).on('blur', "input[data-type='currency']", function (e) {
        formatCurrency($(this), "blur");
    });

    window.check = function (x) {

        if (isNaN(x) || !isFinite(x)) {
            return parseFloat(0).toFixed(2);
        }

        return formatComma(x.toFixed(2));
    }

    window.formatComma = function (input_val, blur) {

        if (input_val.indexOf(".") >= 0) {

            var decimal_pos = input_val.indexOf(".");
            var left_side = input_val.substring(0, decimal_pos);
            var right_side = input_val.substring(decimal_pos);


            left_side = formatNumber(left_side);
            right_side = formatNumber(right_side);
            if (blur === "blur") {
                right_side += "00";
            }

            right_side = right_side.substring(0, 2);
            input_val = left_side + "." + right_side;

        } else {
            input_val = formatNumber(input_val);
            input_val = input_val;

            if (blur === "blur") {
                input_val += ".00";
            }
        }

        return input_val;
    }

    window.isUndefined = function (value) {
        return typeof value === 'undefined';
    }

    window.removeComma = function (n) {

        if (!isUndefined(n)) {
            return n.replace(/,/g, '');
        }
    }

    window.checkForInt = function (x) {

        if (isNaN(x) || !isFinite(x)) {
            return '';
        }

        return parseInt(x);
    }

    window.formatNumber = function (n) {

        return n
            .replace(/(?!-)[^0-9]/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    window.formatContactNumber = function (number) {

        return "+" + number.replace(/^0+/, '');
    };


    window.formatCurrency = function (input, blur) {

        var input_val = input.val();

        if (input_val === "") {
            return;
        }

        // send updated string to input
        input.val(formatComma(input_val, blur));
    }

    window.isEmpty = function (value) {
        return value === '';
    }

    window.arrayIsEmpty = function (array) {
        // If it's not an array, return FALSE.
        if (!Array.isArray(array)) {
            return FALSE;
        }

        // If it is an array, check its length property
        if (array.length == 0) {
            //Return TRUE if the array is empty
            return true;
        }

        //Otherwise, return FALSE.
        return false;
    }

    window.isNull = function (value) {
        return value == null;
    }

    window.isNotNull = function (value) {
        return value != null;
    }


    window.datepickerReset = function (key = null, quoteClass) {
        // console.log(quoteClass)
        // var today;
        // today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        // console.log(today);
        var date = new Date();
        date.setDate(date.getDate());
        var $season = $("#season_id");
        var season_start_date = new Date($season.find(':selected').data('start'));
        var season_end_date = new Date($season.find(':selected').data('end'));
        let createdAt = $('input[name=created_at]');

        if (createdAt.length) {
            let createdAtVal = new Date(createdAt.val());
            $('.datepicker-created').datepicker("destroy").datepicker({
                autoclose: true, format: 'dd/mm/yyyy', startDate: createdAtVal
            });
        }
        // let quoteFirstPayment = $(`${quoteClass} .quote-first-payment`).val();
        // // console.log(quoteFirstPayment);
        // // console.log(quoteClass);
        // if (quoteFirstPayment != '') {
        //     $('.datepicker-refund').datepicker("destroy").datepicker({
        //         autoclose: true, format: 'dd/mm/yyyy', startDate: quoteFirstPayment
        //     })
        // }

        if ($('.fix-datepicker').length) {
            let fixStart = new Date($('.fix-datepicker.start').data('date')),
                fixEnd = new Date($('.fix-datepicker.end').data('date'));
            console.log(fixStart)
            console.log(fixEnd)

            $('.fix-datepicker.start').datepicker("destroy").datepicker({
                autoclose: true, format: 'dd/mm/yyyy', startDate: fixStart, endDate: fixEnd
            });

            $('.fix-datepicker.end').datepicker("destroy").datepicker({
                autoclose: true, format: 'dd/mm/yyyy', startDate: fixStart, endDate: fixEnd
            });
        }
        if ($('.datepicker-refund').length) {
            $('.datepicker-refund').each(function (i, v) {
                let quoteFirstPayment = $(this).parents('.quote').find('.quote-first-payment').val();
                // console.log(quoteFirstPayment);
                $(this).datepicker("destroy").datepicker({
                    autoclose: true, format: 'dd/mm/yyyy', startDate: quoteFirstPayment
                })
            })
        }

        if (season_start_date != 'Invalid Date' && season_end_date != 'Invalid Date') {
            if (key != null) {
                // $(`${quoteClass} .bookingDateOfService`).datepicker('destroy').datepicker({
                //     autoclose: true, format: 'dd/mm/yyyy', startDate: date
                // });
                // $(`${quoteClass} .bookingEndDateOfService`).datepicker('destroy').datepicker({
                //     autoclose: true, format: 'dd/mm/yyyy', startDate: date
                // });
                // $('.datepicker').datepicker("destroy").datepicker({
                //     autoclose: true, format: 'dd/mm/yyyy',
                // });

                $(`${quoteClass} .day`).datepicker('destroy').datepicker({
                    autoclose: true, format: 'dd/mm/yyyy', startDate: date
                });

                $('.datepicker-current').datepicker("destroy").datepicker({
                    autoclose: true, format: 'dd/mm/yyyy', startDate: date
                });

                // $('.bookingDate:last').datepicker('destroy').datepicker({ autoclose: true, format: 'dd/mm/yyyy', startDate: season_start_date, endDate: season_end_date });
                // $('.bookingDueDate:last').datepicker('destroy').datepicker({ autoclose: true, format: 'dd/mm/yyyy', startDate: season_start_date, endDate: season_end_date });

                // $(`${quoteClass} .bookingEndDateOfService`).datepicker('destroy').datepicker({ autoclose: true, format: 'dd/mm/yyyy', startDate: date });
                $('.stored-text-date').datepicker("destroy").datepicker({ autoclose: true, format: 'dd/mm/yyyy' });
            } else {

                // $('.datepicker').datepicker('destroy').datepicker({  autoclose: true, format:'dd/mm/yyyy', startDate: season_start_date, endDate: season_end_date });
                $('.datepicker').datepicker("destroy").datepicker({
                    autoclose: true, format: 'dd/mm/yyyy',
                });

                $('.datepicker-current').datepicker("destroy").datepicker({
                    autoclose: true, format: 'dd/mm/yyyy', startDate: date
                });

                $('.datepicker-dob').datepicker("destroy").datepicker({
                    autoclose: true, format: 'dd/mm/yyyy', endDate: date
                });

                $('.lead-passenger-dbo').datepicker("destroy").datepicker({
                    autoclose: true, format: 'dd/mm/yyyy', endDate: date
                });

                $('.datepicker-current').datepicker("destroy").datepicker({
                    autoclose: true, format: 'dd/mm/yyyy', startDate: date
                });


            }
        } else {
            // console.log('sssss')
            $('.datepicker').datepicker('destroy').datepicker({
                autoclose: true, format: 'dd/mm/yyyy',
            });

            $('.datepicker-current').datepicker("destroy").datepicker({
                autoclose: true, format: 'dd/mm/yyyy', startDate: date
            });
        }

        // console.log('heer')

        /*  Datepicker fixed code for jQuery UI Sortable */
        // $('.datepicker').datepicker({
        //     autoclose: true, format: 'dd/mm/yyyy', startDate: date
        // }).on('hide', function (e) {
        //     $(this).blur();
        // });
    }

    // function intTelinput(key = null, inVal = null) {
    window.intTelinput = function (key = null, preferredCountries = []) {

        let telInputPreferredCountries = arrayIsEmpty(preferredCountries) ? ["gb", "us", "au", "ca", "nz"] : preferredCountries;
        let telInputInitialCountry = arrayIsEmpty(preferredCountries) ? "US" : preferredCountries[0];
        // console.log(preferredCountries)
        window['input' + key] = document.querySelector('.phone' + key);
        window['errorMsg' + key] = document.querySelector('.error_msg' + key);
        window['validMsg' + key] = document.querySelector('.valid_msg' + key);
        window['iti' + key] = intlTelInput(window['input' + key], {
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.3/js/utils.min.js",
            separateDialCode: true,
            preferredCountries: telInputPreferredCountries,
            formatOnDisplay: true,
            initialCountry: telInputInitialCountry,
            nationalMode: true,
            hiddenInput: "full_number",
            autoPlaceholder: "polite",
            placeholderNumberType: "FIXED_LINE_OR_MOBILE",
        });

        window['input' + key].nextElementSibling.value = window['iti' + key].getNumber();
        // iti.setCountry("US");
        // on blur: validate
        window['errorMap' + key] = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];

        window['input' + key].addEventListener('blur', function () {
            window['input' + key].nextElementSibling.value = window['iti' + key].getNumber();
            reset(key);

            if (window['input' + key].value.trim()) {

                validateStyle(window['iti' + key].isValidNumber(), key);
            }
        });

        window.reset = function (key) {

            // console.log(window['input' + key]);
            window['input' + key].classList.remove("is-invalid");
            window['errorMsg' + key].textContent = "";
            window['errorMsg' + key].classList.add("hide");
        };
    }

    window.resetLeadPassengerField = function (key) {

        window['input' + key].classList.remove("is-invalid");
        window['errorMsg' + key].textContent = "";
        window['errorMsg' + key].classList.add("hide");
        $('#lead_passenger_first_name, #lead_passenger_middle_name, #lead_passenger_last_name, #lead_passenger_email, #lead_passenger_contact').val('');
        $('#lead_passsenger_resident').val("").change();
    };

    window.validateStyle = function (validate, key) {

        reset(key);

        if (validate) {
            window['input' + key].classList.add("is-valid");
            window['validMsg' + key].textContent = 'The number is valid';
        } else {
            window['input' + key].classList.add("is-invalid");
            window['validMsg' + key].textContent = '';
            var errorCode = window['iti' + key].getValidationError();

            window['errorMsg' + key].textContent = window['errorMap' + key][errorCode];
            window['errorMsg' + key].classList.remove("hide");
        }
    };


    window.agencyintTelinput = function (key = null, inVal = null) {

        window.agencyinput = document.querySelector('.phone' + key);
        window.agencyerrorMsg = document.querySelector('.error_msg' + key);
        window.agencyvalidMsg = document.querySelector('.valid_msg' + key);
        window.agencyiti = intlTelInput(agencyinput, {
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.3/js/utils.min.js",
            separateDialCode: true,
            preferredCountries: ["gb", "us", "au", "ca", "nz"],
            formatOnDisplay: true,
            initialCountry: "US",
            nationalMode: true,
            hiddenInput: "full_number",
            autoPlaceholder: "polite",
            placeholderNumberType: "FIXED_LINE_OR_MOBILE",
        });

        // agencyiti.setCountry("AU");
        agencyinput.nextElementSibling.value = agencyiti.getNumber();
        // on blur: validate
        window.agencyerrorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];

        agencyinput.addEventListener('blur', function () {
            agencyinput.nextElementSibling.value = agencyiti.getNumber();
            agencyReset();
            if (agencyinput.value.trim()) {
                agencyValidateStyle(agencyiti.isValidNumber());
            }
        });

        window.agencyReset = function () {
            agencyinput.classList.remove("is-invalid");
            agencyerrorMsg.innerHTML = "";
            agencyvalidMsg.classList.add("hide");
        };
    }

    window.agencyValidateStyle = function (validate) {

        agencyReset();

        if (validate) {
            agencyinput.classList.add("is-valid");
            agencyvalidMsg.innerHTML = 'The number is valid';
        } else {
            agencyinput.classList.add("is-invalid");
            agencyvalidMsg.innerHTML = '';
            var errorCode = agencyiti.getValidationError();

            agencyerrorMsg.innerHTML = agencyerrorMap[errorCode];
            agencyerrorMsg.classList.remove("hide");
        }
    };


    if ($('.phone').length > 0) {
        for (let i = 0; i < $('.phone').length; i++) {

            if ($('.phone' + i).length != 0) {
                intTelinput(i);
            }
        }
    }

    if ($('#agency_contact').length > 0) {
        agencyintTelinput('gc');
        // console.log(inTelinput);
    }

    /*
    |--------------------------------------------------------------------------
    | Invoke Global Functions
    |--------------------------------------------------------------------------
    */

    datepickerReset();


    /*  ajaxSetup */
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': CSRFTOKEN,
        }
    });

    $('.select2').select2({
        width: '100%', theme: "classic",
    });

    // Initialize Select2
    reinitializedSingleSelect2();

    $('.select2-multiple').select2({
        width: '100%', theme: "classic", templateResult: formatState, templateSelection: formatState,
        allowClear: true,
        templateSelection: function (data, container) {
            $(container).addClass('opt-inactive');
            return data.text;
        }
    });

    $('.select2-multiple-days').select2({
        width: '100%', theme: "classic", templateResult: formatState, templateSelection: formatState,
        allowClear: true
    });

    //
    function createLFMButton() {
        // Define function to open filemanager window
        const lfm = function (options, cb) {
            var route_prefix = (options && options.prefix) ? options.prefix : (document.getElementById('app_file_manager_url')?.content || (document.location.origin + '/laravel-filemanager'));
            window.open(route_prefix + '?type=' + options.type || 'file', 'FileManager', 'width=900,height=600');
            window.SetUrl = cb;
        };

        // Define LFM summernote button
        const LFMButton = function (context) {
            const ui = $.summernote.ui;
            const button = ui.button({
                contents: '<i class="note-icon-picture"></i> ',
                tooltip: 'Insert image with filemanager',
                click: function () {

                    lfm({ type: 'image', prefix: document.getElementById('app_file_manager_url')?.content || (document.location.origin + '/laravel-filemanager') }, function (lfmItems, path) {
                        lfmItems.forEach(function (lfmItem) {
                            context.invoke('insertImage', lfmItem.url);
                        });
                    });

                }
            });
            return button.render();
        };

        return LFMButton;
    }

    window.initializeSummerNote = function () {

        $('.summernote').summernote({
            height: 70,   //set editable area's height
            placeholder: 'Enter Text Here..',
            codemirror: { // codemirror options
                theme: 'monokai'
            },
            buttons: {
                lfm: createLFMButton()
            },
            toolbar: [['style', ['bold', 'italic', 'underline', 'clear']], ['font', ['strikethrough', 'superscript', 'subscript']], ['fontname', ['fontname']], ['fontsize', ['fontsize']], ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']], ['insert', ['lfm']], ['height', ['height']]]
        });

    };

    initializeSummerNote();


    // make quote section sortable
    // $(document).on('click', function (e) {
    //     var $popover = $('[data-toggle="popover"]');
    //     if (!$(e.target).closest($popover).length) {
    //         $popover.popover('hide');
    //     }
    // });

    // $(".sortable").sortable({
    //     // disabled: true,
    //     axis: "y",
    //     update: function (event, ui) {
    //         $('[data-toggle="popover"]').popover();
    //     }
    // });

    // $( ".sortable" ).on( "sortupdate", function( event, ui ) {
    //     let item = ui.item;

    // } );

    $('body').on('expanded.lte.cardwidget', '.collapse-expand-btn', function () {
        console.log('ss1')

        // $(this).closest('.quote').addClass('unsortable');

        // $(".sortable").sortable({
        //     cancel: ".unsortable"
        // });
        // $(".sortable").sortable("refresh");
    });


    $('body').on('collapsed.lte.cardwidget', '.collapse-expand-btn', function () {
        // console.log('ss2')
        // $(this).closest('.quote').removeClass('unsortable');

        // $( ".selector" ).sortable( "enable" );
        // $(".sortable").sortable({
        //     disabled: false, cancel: ".unsortable"
        // });
        // $(".sortable").sortable("refresh");
    });

    var keyupTimeout = null;
    $(document).on('keyup', '.markup-input', function (e) {
        e.preventDefault();
        let $this = $(this);
        clearTimeout(keyupTimeout);
        keyupTimeout = setTimeout(function () {
            let val = $this.val(),
                parentDiv = $this.parents('.faretype-cp'),
                markupType = parentDiv.find('.markup-type select :selected').val(),
                scVal = parentDiv.find('.parent-field').val(),
                percAmount = 0;

            if (markupType == 'percentage') {
                percAmount = parseFloat((val / 100) * scVal).toFixed(2);
                $this.parents('.markup-amount').find('.invalid-feedback').text(percAmount).css('color', 'blue');
            } else {
                $this.parents('.markup-amount').find('.invalid-feedback').text('').css('color', '');
            }

        }, 1000);
    })

    $('.date-range-picker').daterangepicker({
        autoUpdateInput: false, locale: {
            cancelLabel: 'Clear', format: 'DD/MM/YYYY',
        }
    });

    $('.date-range-picker').on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
    });

    $('.date-range-picker').on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });

    /*---------------------------------------------------------------------------------------*/

    $(document).on('click', '.view-modal-btn', function (e) {
        e.preventDefault();
        let parentDiv = $(this).parents('.table-listing'),
            modal = parentDiv.find('.view-modal-popup'),
            url = $(this).data('action'),
            modalContentDiv = modal.find('.view-modal-content');
        console.log(url);
        $.ajax({
            type: "GET",
            url: url,
            success: function success(response) {
                if (response.html) {
                    modalContentDiv.html(response.html)
                }
                modal.modal('show');

            }
        });
    })

    $(document).on('change', '.ajax-opt', function () {

        let $this = $(this),
            parentDiv = $this.parents('.ajax-itinerary'),
            tourId = $this.find("option:selected").data("tour-id"),
            optId = $this.val();

        $.ajax({
            type: 'get',
            url: `${BASEURL}show-tour-day`,
            data: {
                tour_id: tourId,
                opt_id: optId,
            },
            beforeSend: function () {

            },
            success: function (resp) {
                if (resp.html) {
                    parentDiv.find('.opt-data').html(resp.html);
                }
            },
            error: function () {

            }

        });

    });

    $(document).on('click', '.form-modal-btn', function (e) {
        e.preventDefault();
        let parentDiv = $(this).parents('.modal-form'),
            modal = parentDiv.find('.ufg-modal-popup'),
            url = $(this).data('action'),
            module = $(this).data('module_name'),
            modalContentDiv = modal.find('.form-modal-content'),
            optId = $(this).data('opt_id');

        if (optId) {
            url += "?opt_id=" + optId;
        }

        $.ajax({
            type: "GET",
            url: url,
            success: function success(response) {
                if (response.html) {
                    modalContentDiv.html(response.html)
                    // $('.lfm_image').filemanager('image', {prefix: FILE_MANAGER_URL});
                    $('.lfm_file').filemanager('file', { prefix: FILE_MANAGER_URL });
                }

                $('.module-title').text(module);
                modal.modal('show');
                reinitializedSummerNote(modal);
                reinitializedSingleSelect2();
            }
        });
    })

    function reinitializedSummerNote(modal, height = 70) {

        jQuery('.note-editor').remove();
        jQuery(modal).find('.summernote').summernote({
            height: height,   //set editable area's height
            placeholder: 'Enter Text Here..',
            codemirror: { // codemirror options
                theme: 'monokai'
            },
        });
    }


    /* Focus In/Out Function on Calculation Values */
    $(document).on('focus', '.remove-zero-values', function () {
        var value = parseFloat($(this).val()).toFixed(2);
        if (value == 0.00) {
            $(this).val('');
        }
    });

    $(document).on('focusout', '.remove-zero-values', function () {
        var value = $(this).val();
        // console.log(parseFloat(0).toFixed(2));
        if (value == '') {
            $(this).val((parseFloat(0).toFixed(2)));
        }
    });
    /* End Focus In/Out Function on Calculation Values */

    $(document).on('focus', '.remove-single-zero', function () {
        var value = parseFloat($(this).val()).toFixed(2);
        if (value == 0) {
            $(this).val('');
        }
    });

    $(document).on('focusout', '.remove-single-zero', function () {
        var value = $(this).val();
        if (value == '') {
            $(this).val((parseFloat(0).toFixed()));
        }
    });

    // $(document).on('click', '.listing-col-sort', function (e) {
    //     e.preventDefault();
    //     let sortRoute = $(this).attr('href'),
    //         orderBy = $(this).attr('order-by'),
    //         order = $(this).attr('order');
    //     window.location.href = sortRoute + '?orderBy=' + orderBy + '&order=' + order;
    // })

    $(document).on('change', '.select-agency', function () {
        var agency_ = $('.agencyField');
        var passenger_ = $('.PassengerField');

        if (($(this).val() == 1)) {
            $('#pax_no').val(1).change();
            $("input[name=agency_commission_type][value=net-price]").prop('checked', true);
            agency_.removeClass('d-none');
            passenger_.addClass('d-none');
            agency_.find('input, select').removeAttr('disabled');
            passenger_.find('input, select').attr('disabled', 'disabled');
            // $('#agency_contact').addClass('phone phone0');
            // $('#lead_passenger_contact').removeClass('phone');
            // $('#lead_passenger_contact').removeClass('phone0');
            var iti = intlTelInput(document.querySelector('#lead_passenger_contact'), {
                utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.3/js/utils.min.js",
            });
            iti.destroy();
            // intTelinput('gc');
        } else {
            $('#pax_no').val(1).change();
            $('.paid-net-commission-on-departure').addClass('d-none');
            agency_.addClass('d-none');
            passenger_.removeClass('d-none');
            passenger_.find('input, select').removeAttr('disabled');
            var iti = intlTelInput(document.querySelector('#agency_contact'), {
                utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.3/js/utils.min.js",
            });
            iti.destroy();
            // $('#lead_passenger_contact').addClass('phone phone0');
            // $('#agency_contact').removeClass('phone');
            // $('#agency_contact').removeClass('phone0');
            agency_.find('input, select').attr('disabled', 'disabled');
            // intTelinput(0);
        }
        $('.passenger:visible').find('.passenger-name-store').trigger('change')

        getCommissionRate();
    });

    $(document).on('click', '.expand-all-btn', function (event) {
        $('#parent .quote').removeClass('collapsed-card');
        $('#parent .card-body').css("display", "block");
        $('#parent .collapse-expand-btn').html(`<i class="fas fa-minus"></i>`);
        // $(this).addClass('d-none');
        // $('.expand-collapse-quote-detail-cards').removeClass('d-none');
    });

    $(document).on('click', '.compare-expand-all-btn', function (event) {
        $('#compare_parent .card').removeClass('collapsed-card');
        $('#compare_parent .card-body').css("display", "block");
        $('#compare_parent .compare-collapse-expand-btn').html(`<i class="fas fa-minus"></i>`);
    });

    $(document).on('click', '.compare-expand-collapse-quote-detail-cards', function (event) {

        $('#compare_parent .card').addClass('collapsed-card');
        $('#compare_parent .card-body').css("display", "none");
        $('#compare_parent .compare-collapse-expand-btn').html(`<i class="fas fa-plus"></i>`);
    });

    /**
     * -------------------------------------------------------------------------------------
     *                                Quote Manangement
     * -------------------------------------------------------------------------------------
     */

    $(document).on('click', '.zero-one-checkbox', function () {

        let value = $(this).val();

        if (value == 0) {
            $(this).val(1);
        } else {
            $(this).val(0);
        }

    });

    $(document).on('click', '.finance-parent', function () {

        if ($(this).is(':checked', true)) {
            $(".finance-child")
                .prop('checked', true)
                .val(1);

        } else {

            $(".finance-child")
                .prop('checked', false)
                .val(0);
        }
    });

    $(document).on('click', '.parent-row', function (e) {
        var parentID = $(this).data('id');
        $(`#child-row-${parentID}`).hasClass('d-none') ? $(`#child-row-${parentID}`).removeClass('d-none') : $(`#child-row-${parentID}`).addClass('d-none');
        $(this).html($(this).html() == `<span class="fa fa-minus"></span>` ? `<span class="fa fa-plus"></span>` : `<span class="fa fa-minus"></span>`);
    });

    $(".readonly").keypress(function (evt) {
        evt.preventDefault();
    });

    $(".collapse-all-btn").removeAttr('disabled');
    $(".expand-all-btn").removeAttr('disabled');

    // transfer report
    function createFilter(type, label, data) {

        var options;

        if (label == null) {
            $('.filter-col').remove();
            return;
        }

        $.ajax({
            type: "GET",
            url: `${BASEURL}category-details-filter`,
            data: { 'type': type, 'label': label, 'data': data },
            datatype: "json",
            async: false,
            success: function (response) {

                var result = '';
                $.each(response.label_results, function (key, value) {
                    result += `<option value="${value.value}"> ${value.value} </option>`;
                });

                options = result;
            }
        });

        var multipleSelect2HTML = `<div class="col-md-3 filter-col">
            <div class="d-flex bd-highlight">
                <div class="w-100 bd-highlight"><label>${label}</label></div>
                <div class="flex-shrink-1 bd-highlight" style="font-size: 11px;"><i class="fas fa-times invalid-feedback border border-danger remove-col" style="padding: 4px; border-radius: 4px; cursor: pointer;"></i></div>
            </div>
            <select class="form-control select2-multiple" multiple name="columns[${label}][]">${options}</select>
        </div>`;

        return multipleSelect2HTML;
    }


    // transfer report
    // $(document).on('change', '.transfer-detail-feild', function () {

    //     var feild = $(this).val();

    //     if (typeof feild === 'undefined' || feild == "") {
    //         $('#search_transfer_detail').addClass('d-none');
    //     } else {
    //         $('#search_transfer_detail').removeClass('d-none');
    //     }

    //     var type = $(this).find(':selected').attr('data-optionType');
    //     var label = $(this).find(':selected').attr('data-optionLable');
    //     var data = $(this).find(':selected').attr('data-optionData');

    //     $(createFilter(type, label, data)).insertBefore("#more_filter");
    //     reinitializedMultipleSelect2();
    // });


    // transfer report
    $(document).on('click', '.remove-col', function () {
        $(this).closest('.filter-col').remove();
    });

    $(document).on('click', '.parent', function () {
        let parentTable = $(this).parents('table');

        if ($(this).is(':checked', true)) {
            parentTable.find(".child").prop('checked', true).trigger('change');
        } else {
            parentTable.find(".child").prop('checked', false).trigger('change');
        }
    });

    $('.sbp-parent').on('click', function (e) {

        if ($(this).is(':checked', true)) {

            $(".credit").prop('checked', false);
            $('.credit').trigger('click');

        } else {

            $('.credit').trigger('click');
            $('.total-paid-amount').val(parseFloat(0).toFixed(2));

        }
    });

    // Supplier Bulk Payments
    $('.credit').change(function () {

        var currencyCode = $(this).attr('data-currencyCode');
        var value = parseFloat($(this).attr('data-value')).toFixed(2);
        var row = $(this).closest('.credit-row');

        if ($(this).is(':checked')) {

            $(this).val('1');

            row.find('.row-paid-amount').val(value);
            row.find('.row-total-paid-amount').val(value);

            getTotalPaidAmount();

        } else {

            $(this).val('0');

            row.find('.row-paid-amount').val((parseFloat(0).toFixed(2)));
            row.find('.row-total-paid-amount').val((parseFloat(0).toFixed(2)));
            getTotalPaidAmount();
            // $('.total-paid-amount').val((parseFloat(getCheckedValues()).toFixed(2)));
        }

    });

    // Supplier Bulk Payments
    $(document).on("change", '.row-paid-amount', function (event) {

        var row = $(this).closest('.credit-row');
        var currentPaidAmountValue = parseFloat($(this).val());

        var rowCreditNoteAmount = row.find('.row-credit-note-amount').val();
        var rowTotalPaidAmount = parseFloat(currentPaidAmountValue) + parseFloat(rowCreditNoteAmount);

        var totalOutstandingAmountLeft = parseFloat(row.find('.credit').attr('data-value'));

        row.find('.row-total-paid-amount').val(getFloat(rowTotalPaidAmount));


        if (rowTotalPaidAmount > totalOutstandingAmountLeft) {
            alert("Please Enter Correct Amount");
            $(this).val('0.00');


            row.find('.row-total-paid-amount').val(getFloat(rowCreditNoteAmount));
        }

        getTotalPaidAmount();

        // var value                 = parseFloat($(this).val());
        // var row                   = $(this).closest('.credit-row');
        // var outstandingAmountLeft = row.find('.credit').val();

        // if(value > outstandingAmountLeft){
        //     alert("Please Enter Correct Amount");
        //     $(this).val('0.00');
        // }

        // getTotalPaidAmount();
    });

    function getTotalPaidAmount() {

        var paidAmountValues = parseFloat(getPaidAmountValues());
        $('.total-paid-amount').val(getFloat(paidAmountValues));
    }

    function getRemainingCreditNoteAmount() {

        var totalWalletAmount = parseFloat($('.total-credit-amount').val());
        var totalCreditNoteValues = parseFloat(getCreditNoteValues());
        var result = parseFloat(totalWalletAmount) - parseFloat(totalCreditNoteValues);

        $('.remaining-credit-amount').html(getFloat(result));
        $('.remaining-credit-amount').val(getFloat(result));
    }

    function getPaidAmountValues() {
        var checkedValuesArray = $('.row-total-paid-amount').map((i, e) => parseFloat(e.value)).get();
        var checkedValuesTotal = checkedValuesArray.reduce((a, b) => (a + b), 0);
        return parseFloat(checkedValuesTotal).toFixed(2);
    }

    function getCreditNoteValues() {
        var checkedValuesArray = $('.row-credit-note-amount').map((i, e) => parseFloat(e.value)).get();
        var checkedValuesTotal = checkedValuesArray.reduce((a, b) => (a + b), 0);
        return parseFloat(checkedValuesTotal).toFixed(2);
    }

    function getFloat(value) {
        // console.log(parseFloat(value).toFixed(2));
        return parseFloat(value).toFixed(2);
    }

    // Supplier Bulk Payments
    $(document).on("change", '.row-credit-note-amount', function (event) {

        var totalWalletAmount = parseFloat($('.total-credit-amount').val());
        var currentCreditNoteValue = parseFloat($(this).val());

        var row = $(this).closest('.credit-row');
        var rowOutstandingAmount = row.find('.credit').attr('data-value');

        var rowPaidAmount = parseFloat(rowOutstandingAmount) - parseFloat(currentCreditNoteValue);
        var rowTotalPaidAmount = parseFloat(rowPaidAmount) + parseFloat(currentCreditNoteValue);

        var totalCreditNoteValues = parseFloat(getCreditNoteValues());

        if (row.find('.credit').is(':checked')) {

            row.find('.row-paid-amount').val(getFloat(rowPaidAmount));
            row.find('.row-total-paid-amount').val(getFloat(rowTotalPaidAmount));

            if (currentCreditNoteValue > totalWalletAmount || totalCreditNoteValues > totalWalletAmount) {

                alert("Please Enter Correct Amount");
                $(this).val('0.00');

                row.find('.row-paid-amount').val(getFloat(rowOutstandingAmount));
                row.find('.row-total-paid-amount').val(getFloat(rowOutstandingAmount));
            }


            getTotalPaidAmount();
            getRemainingCreditNoteAmount();
        } else {
            $(this).val('0.00');
        }
    });

    // Supplier Bulk Payments
    $("#bulk_payment").submit(function (event) {

        event.preventDefault();

        var checkedValues = $('.credit:checked').map((i, e) => e.value).get();
        if (checkedValues.length == 0) {
            alert("Please Check any Record First");
            return;
        }

        var url = $(this).attr('action');

        $.ajax({
            type: 'POST',
            url: url,
            data: new FormData(this),
            contentType: false,
            cache: false,
            processData: false,
            beforeSend: function () {
                $('input, select').removeClass('is-invalid');
                $('.invalid-feedback').html('');
                $("#bulk_payment_submit").find('span').addClass('spinner-border spinner-border-sm');
            },
            success: function (data) {
                $("#bulk_payment_submit").find('span').removeClass('spinner-border spinner-border-sm');

                setTimeout(function () {

                    if (data && data.status == true) {
                        alert(data.success_message);
                        location.reload();
                    }
                }, 200);
            },
            error: function (reject) {

                if (reject.status === 422) {

                    var errors = $.parseJSON(reject.responseText);

                    setTimeout(function () {
                        $("#bulk_payment_submit").find('span').removeClass('spinner-border spinner-border-sm');

                        if (errors.hasOwnProperty("payment_error")) {
                            alert(errors.payment_error);
                            location.reload();

                        } else {

                            var flag = true;

                            jQuery.each(errors.errors, function (index, value) {

                                index = index.replace(/\./g, '_');
                                $(`#${index}`).addClass('is-invalid');
                                $(`#${index}`).closest('.form-group').find('.invalid-feedback').html(value);

                                if (flag) {

                                    $('html, body').animate({ scrollTop: $(`#${index}`).offset().top }, 1000);
                                    flag = false;
                                }
                            });
                        }

                    }, 400);


                }
            },
        });
    });

    $(document).on('change', '.selectStoredText', function () {

        var slug = $(this).val();
        var quote = jQuery(this).closest('.quote');
        var key = quote.data('key');
        $.ajax({
            url: `${BASEURL}stored/${slug}/text`, type: 'get', dataType: "json", success: function (data) {
                setTextEditorValue(`#quote_${key}_stored_text`, data);
            }, error: function (reject) {
                alert(reject);
            },
        });

    });

    $(document).on('click', '.addmodalforquote', function () {

        var quote = $(this).closest('.quote');
        var key = quote.data('key');
        var target = '.' + $(this).data('show');
        // console.log(target);
        quote.find(target).modal('show');
        quote.find(target + ':input').removeAttr('disabled');
        // jQuery('#accomadation_modal').modal('show').find('input').val('');
    });


    $(document).on('click', '.removeChild', function () {
        var id = $(this).data('show');
        $(id).removeAttr("style");
        $($(this).data('append')).empty();
        $(this).attr("style", "display:none");
    });

    $(document).on('click', '.addChild', function () {
        $('.append').empty();
        var id = $(this).data('id');
        var refNumber = $(this).data('ref');
        var appendId = $(this).data('append');
        var url = '{{ route("get.child.reference", ":id") }}';
        url = url.replace(':id', refNumber);
        var removeBtnId = $(this).data('remove');
        var showBtnId = $(this).data('show');
        $('.addChild').removeAttr("style");
        $('.removeChild').attr("style", "display:none");

        $(this).attr("style", "display:none")
        // $(appendId).empty();

        $.ajax({
            url: BASEURL + 'quotes/child/reference',
            data: { id: id, ref_no: refNumber },
            type: 'get',
            success: function (response) {
                $(appendId).append(response);
                $(removeBtnId).removeAttr("style");
            }
        });
    });

    window.getFutureDate = function (quoteLength) {
        let previousData = quoteLength - 1;
        let service_date = $(`#quote_${previousData}_end_date_of_service`).val();

        if (quoteLength > 1) {
            if (!isEmpty(service_date)) {
                const today = new Date(convertDate(service_date));
                const yyyy = today.getFullYear();
                let mm = today.getMonth() + 1; // Months start at 0!
                let dd = today.getDate() + 1;
                const formattedToday = dd + '/' + mm + '/' + yyyy;
                // console.log(formattedToday);
                let cat = $(`#quote_${quoteLength}_category_id`).find(':selected').val();
                $(`#quote_${quoteLength}_date_of_service`).val(service_date);
                $(`#quote_${quoteLength}_date_of_service`).datepicker("setDate", service_date);
                $(`#quote_${quoteLength}_end_date_of_service`).datepicker("setDate", cat == '2' ? '' : service_date);
                $(`#quote_${quoteLength}_day`).datepicker("setDate", service_date);
            } else {
                $(`#quote_${quoteLength}_date_of_service`).val('');
                $(`#quote_${quoteLength}_date_of_service`).datepicker("setDate", '');
                $(`#quote_${quoteLength}_end_date_of_service`).datepicker("setDate", '');
            }
        }
    }

    // Start Date should be greater than End Date
    $(document).on('change', '.start-date', function () {
        let startDate = $(this).val(), endDateElement = $('.end-date'), endDate = endDateElement.datepicker({
            format: 'mm/dd/yyyy',
        }), sameDatesAllowed = endDateElement.hasClass('sameDatesAllowed');
        endDate.datepicker('setStartDate', startDate);
        let currentEndDate = endDateElement.datepicker('getDate');

        if (!currentEndDate || currentEndDate < startDate) {
            endDate.datepicker('setDate', null);
        }
        // endDate.datepicker('setDate', null);

        if (!sameDatesAllowed || undefined) {
            endDate.datepicker('setDatesDisabled', [startDate]);
        }
    });

    // Start Date should be greater than End Date at same page need 2 time date
    $(document).on('change', '.start-date-1', function () {
        let startDate = $(this).val(), endDateElement = $('.end-date-1'), endDate = endDateElement.datepicker({
            format: 'mm/dd/yyyy',
        });
        let sameDatesAllowed = endDateElement.hasClass('sameDatesAllowed');

        endDate.datepicker('setStartDate', startDate);
        endDate.datepicker('setDate', null);

        if (!sameDatesAllowed || undefined) {
            endDate.datepicker('setDatesDisabled', [startDate]);
        }
    });


    // Check zero values
    $(document).on('change', '.check-zero-value', function () {
        if ($(this).val() == 0) {
            $(this).val('');
            $(this).addClass('is-invalid');
            Toast.fire({
                icon: 'error', title: 'Value should be greater than 0'
            });
        } else {
            $(this).removeClass('is-invalid');
        }
    });

    function setCookie(name, value, days) {
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + days);
        const cookieValue = encodeURIComponent(value) + (days ? `; expires=${expirationDate.toUTCString()}` : '');
        document.cookie = `${name}=${cookieValue}; path=/`;
    }

    function getCookie(name) {
        const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return cookieValue ? decodeURIComponent(cookieValue.pop()) : null;
    }

    function clearCookie(name) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }

    function updateInputField(inputId, cookieName) {
        const inputValue = getCookie(cookieName);
        if (inputValue) {
            $(`#${inputId}`).val(inputValue);
        }
    }

    function setCookieAndInput(cookieName, inputValue, inputId, days) {
        clearCookie(cookieName);
        setCookie(cookieName, inputValue, days);
        updateInputField(inputId, cookieName);
    }

    // Save & Next Button Tab Function for Hotel & Transfer Modules
    $('#buttonSaveNext').on('click', function (event) {

        event.preventDefault();
        let activeTabLink = $('.nav-tabs').find('.nav-link.active');
        let nextTabLink = activeTabLink.parent().next().find('a.nav-link');
        let form = $(this).closest('form');
        let url = form.attr('action');
        let formID = form.attr('id');
        // console.log(formID);
        let formData = $("#" + formID).serialize();
        // console.log(activeTabLink)
        // console.log(nextTabLink)

        // console.log(formID)
        // console.log(formData)
        // return;
        // console.log(formID);
        // console.log(Array.isArray(emptyArray) && emptyArray.length)
        if ($(`#${formID}`).hasClass('render-req') && $('.form_rendered').length === 0) {
            $('.add_new_form').click();

            // return true;
        }

        // setTimeout(function () {

        $.ajax({
            type: 'POST', url: url, data: formData, cache: false, processData: false, beforeSend: function () {
                removeFormValidationStyles();
                addFormLoadingStyles();
            }, success: function (response) {

                removeFormLoadingStyles();
                printListingSuccessMessage(response);

                setTimeout(function () {
                    // if (formID == 'store_hotel_detail') {
                    //     let id = $('.hotel-cookie-id').data('id');
                    //     let cookie_url = $('.hotel-cookie-id').data('action');
                    //     clearCookie('id');
                    //     setCookie('id', id, 7);
                    //     window.location.href = cookie_url;
                    // }

                    while (nextTabLink.length && nextTabLink.attr('href').includes('#')) {
                        nextTabLink = nextTabLink.parent().next().find('a.nav-link');
                    }

                    if (nextTabLink.length) {
                        let nextTabHref = nextTabLink.attr('href');
                        window.location.href = nextTabHref;
                    }
                }, 1000);
            }, error: function (response) {

                removeFormLoadingStyles();
                printServerValidationErrors(response);
            }
        });

        // }, 100);
    });

    // Help Content
    $('#submit_help_content').on('click', function (e) {
        e.preventDefault();
        var url = $(this).data('action');
        var formData = new FormData();
        var modalId = $(this).data('modal-id');
        console.log(modalId);

        if (modalId === 'booking_rule_stay_start_date') {
            formData.append('booking_rule_stay_start_date', $('textarea#booking_rule_stay_start_date').val());
        } else if (modalId === 'booking_rule_stay_end_date') {
            formData.append('booking_rule_stay_end_date', $('textarea#booking_rule_stay_end_date').val());
        } else if (modalId === 'booking_rule_min_stay') {
            formData.append('booking_rule_min_stay', $('textarea#booking_rule_min_stay').val());
        } else if (modalId === 'booking_rule_max_stay') {
            formData.append('booking_rule_max_stay', $('textarea#booking_rule_max_stay').val());
        } else if (modalId === 'booking_rule_available_days_ids') {
            formData.append('booking_rule_available_days_ids', $('textarea#booking_rule_available_days_ids').val());
        } else if (modalId === 'booking_rule_arrival_days_ids') {
            formData.append('booking_rule_arrival_days_ids', $('textarea#booking_rule_arrival_days_ids').val());
        } else if (modalId === 'booking_rule_departure_days_ids') {
            formData.append('booking_rule_departure_days_ids', $('textarea#booking_rule_departure_days_ids').val());
        } else if (modalId === 'booking_rule_required_days_ids') {
            formData.append('booking_rule_required_days_ids', $('textarea#booking_rule_required_days_ids').val());
        } else if (modalId === 'booking_rule_sell_channel_ids') {
            formData.append('booking_rule_sell_channel_ids', $('textarea#booking_rule_sell_channel_ids').val());
        } else if (modalId === 'booking_rule_check_in_min') {
            formData.append('booking_rule_check_in_min', $('textarea#booking_rule_check_in_min').val());
        } else if (modalId === 'booking_rule_check_in_max') {
            formData.append('booking_rule_check_in_max', $('textarea#booking_rule_check_in_max').val());
        } else if (modalId === 'booking_rule_check_out_min') {
            formData.append('booking_rule_check_out_min', $('textarea#booking_rule_check_out_min').val());
        } else if (modalId === 'booking_rule_check_out_max') {
            formData.append('booking_rule_check_out_max', $('textarea#booking_rule_check_out_max').val());
        }

        $.ajax({
            type: 'POST', url: url, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, data: formData, contentType: false, cache: false, processData: false, beforeSend: function () {
                removeFormValidationStyles();
            }, success: function (response) {
                printServerSuccessMessage(response);
                console.log(data);
            }, error: function (response) {
                removeFormLoadingStyles();
                printServerValidationErrors(response);
            }
        });
    });

    $(document).on('input', 'input[type=number], input[type=text]', (event) => {
        let that = $(event.target), maxLength = that.data('max_length');
        that.removeClass('is-invalid');

        if (that.hasClass('max-length') && that.val().length > maxLength) {
            that.val(that.val().substring(0, maxLength));
        }

        if (that.hasClass('prevent-first-zero') && that.val().length === 1) {
            that.val(that.val().replace(/^0+/, ''));
        }

    });

    $(document).on('keyup', '.check-validation', function () {

        let key = $(this).data('key');
        setTimeout(() => {
            let [min, max] = [`.min-value-${key}`, `.max-value-${key}`].map(selector => parseInt(($(selector).val())) || 0);
            const feedback = document.querySelector(`.min-value-${key}` + `+ .invalid-feedback`);

            if (min > 0 && max > 0) {
                if (min > max) {
                    // If min is greater than max, show the error message
                    if (feedback) {
                        feedback.innerHTML = 'Min cannot be greater than Max'; // Message set karna
                        feedback.style.display = 'block'; // Element ko visible karna
                    }
                } else {
                    // If min is not greater than max, clear the error message
                    if (feedback) {
                        feedback.innerHTML = ''; // Clear the message
                        feedback.style.display = 'none'; // Hide the element
                    }
                }
            }
        }, 1000);

    });

    // number maximum length
    $(document).on('keyup', '.max-number', function () {
        var ref = $(this), val = ref.val();
        if (val.length >= 3) {
            ref.val(function () {
                console.log(val.substr(0, 3))
                return val.substr(0, 3);
            });
        }
    });

    $('.only-text').on('keypress', function (event) {
        var inputValue = event.key;
        var regex = /^[a-zA-Z]+$/;
        if (!regex.test(inputValue)) {
            event.preventDefault();
            Toast.fire({
                icon: 'error', title: 'Only text allowed'
            });
        }
    });

    $(document).on('keydown', '.prevent-decimal-value', function (event) {
        if (event.key === '.') {
            event.preventDefault();
        }
    });

    $(document).on('keydown', '.prevent-negative-value', function (event) {
        if (event.key === '-') {
            event.preventDefault();
        }
    });

    $(document).on('keydown', '.prevent-zero-value', function (event) {
        if (event.key === '0') {
            event.preventDefault();
        }
    });

    $('#supplier_id').on('change', function () {
        var supplierId = $(this).val();
        var selectedCurrencyId = $(this).find('option:selected').data('currency-id');
        if (supplierId) {
            $('#currency_id').val(selectedCurrencyId).trigger('change');
        }
    });

    window.loading = `<div class="p-3">
        <div class="col-12 p-2 mb-2 animated-background"></div>
        <div class="col-8 p-2 animated-background"></div>
    </div>`;

    // ***
    // Reset the form by form id
    // ***
    window.resetForm = (formId) => $(`${formId}`).trigger('reset');

    //     // This function is used for hotel contracts
    //     $("#hotel_id").on("change", function() {

    //         const id           = $(this).val();
    //         const selectedUrl  = $(this).data("action");
    //         const urlWithId    = buildUrlWithId(selectedUrl, id);

    //         if (id === '') {
    //             // If ID is empty, use data-urlwithoutid attribute to redirect
    //             const emptyIdUrl = $(this).data("urlwithoutid");
    //             window.location.href = emptyIdUrl;
    //         } else {
    //             // If ID is not empty, check if urlWithId is valid and redirect
    //             if (urlWithId) {
    //                 redirectToUrl(urlWithId);
    //             }
    //         }

    //     });

    //    // This function is used for Hotel Contract Tabs
    //    $("#contractDetail, #room, #ratePlan, #bookingRule, #cancellationPolicy, #supplierCommission, #supplierCost, #customerPrice, #allocationGroup, #allocationStopSale, #supplement, #offer, #imageGalary").on("click", function() {

    //         const id            = $(this).data("id");
    //         const selectedUrl   = $(this).data("action");
    //         const urlWithId     = buildUrlWithId(selectedUrl, id);

    //         if (urlWithId) {
    //             redirectToUrl(urlWithId);
    //         }

    //     });

    //     // This function is used to redirect to the create page of the hotel contract when the 'Add' button is clicked
    //     $(document).on("click", "#get_hotel_id_to_create_page", function() {

    //         const id          = $('#hotel_id').val();
    //         const selectedUrl = $(this).data("action");
    //         const urlWithId   = buildUrlWithId(selectedUrl, id);

    //         if (urlWithId) {
    //             redirectToUrl(urlWithId);
    //         }

    //     });

    //     // Function to build the URL with the ID as a query parameter
    //     function buildUrlWithId(url, id) {
    //         const params = new URLSearchParams({ id });
    //         return url + "?" + params.toString();
    //     }

    //     // Function to redirect to the specified URL
    //     function redirectToUrl(url) {
    //         window.location.href = url;
    //     }

    // $('.default-open').addClass('collapsed-card');
});

//in start don't allow zero in input field
//  for calling ( oninput="zeroValueNotAllow(this)" )
window.zeroValueNotAllow = function (input) {
    if (input.value.length === 1 && input.value === '0') {
        input.value = '';
    }
}

// ScrollBar jQuery for table top and bottom
jQuery(function () {
    var tableContainer = jQuery(".table-responsive");
    var table = jQuery(".table-responsive table");
    var fakeContainer = jQuery(".topScrollBar");
    var fakeDiv = jQuery(".topScrollBar div");

    var tableWidth = table.width();
    fakeDiv.width(tableWidth);

    fakeContainer.scroll(function () {
        tableContainer.scrollLeft(fakeContainer.scrollLeft());
    });
    tableContainer.scroll(function () {
        fakeContainer.scrollLeft(tableContainer.scrollLeft());
    });
});

// HX jQuery
jQuery(function () {

    // customFilter

    // if(jQuery('.customFilter .card').hasClass('collapsed-card')){
    //     jQuery('.customFilter .card-header').find('.fa-angle-down').removeClass('fa-angle-down').addClass('fa-plus font12');
    // }else{
    //     // jQuery('.customFilter .card').addClass('collapsed-card');
    //     if(jQuery('.customFilter .card').hasClass('collapsed-card') || jQuery('.customFilter .card-header').hasClass('active')){
    //         jQuery('.customFilter .card-header').find('.fa-angle-down').removeClass('fa-angle-down').addClass('fa-minus');
    //     }else{
    //         jQuery('.customFilter .card-header').find('.fa-angle-down').removeClass('fa-angle-down').addClass('fa-plus font12');
    //     }

    // }

    jQuery('.customFilter .card .btn-tool').on('click', function () {
        let cardHeader = jQuery(this).parents('.card');

        if (cardHeader.hasClass('collapsed-card')) {
            cardHeader.find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
        } else {
            cardHeader.find('.fa-minus').removeClass('fa-minus').addClass('fa-plus');
        }
    });

    // .collapse-expand-button
    $(document).on('click', '.collapse-expand-button', function (e) {
        let $this = $(this),
            parentDiv = $this.parents('.data-wrap'),
            cards = parentDiv.find('.card-default');
        // cards.toggleClass('collapsed-card');
        $this.toggleClass('active');
        cards.addClass('collapsed-card');
        // cards.find('.card-body').slideUp();

        let Icons = cards.find('.card-tools .btn i');

        if ($this.hasClass('active')) {
            $this.text('Collapse All');
            cards.removeClass('collapsed-card');
            cards.find('.card-body').slideDown();
        } else {
            $this.text('Expand All');
            cards.addClass('collapsed-card');
            cards.find('.card-body').slideUp();
        }

        if (cards.hasClass('collapsed-card')) {
            if (Icons.hasClass('fa-minus')) {
                Icons.removeClass('fa-minus')
                Icons.addClass('fa-plus');
            }
        } else {
            Icons.removeClass('fa-plus');
            Icons.addClass('fa-minus')
        }
    });

    // table inner Scroll

    jQuery('.trScroll').each(function () {
        // console.log('sdeeeeeeeeee')
        let thscroll = jQuery('table.scrollTable').find(".thScroll");
        let tdscroll = jQuery('table.scrollTable').find(".tdScroll");

        // console.log('sdeeeeeeeeee')
        thscroll.scroll(function () {
            let scrollLeft = $(this).scrollLeft();
            tdscroll.scrollLeft(scrollLeft);
        });

        tdscroll.scroll(function () {
            let scrollLeft = $(this).scrollLeft();
            tdscroll.each(function () {
                thscroll.scrollLeft(scrollLeft);
            })
        });
    })

    // Sidebar icon
    jQuery('.sidebar .nav-item').find('.fa-angle-left').removeClass('fa-angle-left').addClass('fa-plus');
    setInterval(function () {
        jQuery('.sidebar .nav-item').each(function () {
            if (jQuery(this).hasClass('menu-is-opening') || jQuery(this).hasClass('menu-open')) {
                jQuery(this).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
            } else {
                jQuery(this).find('.fa-minus').removeClass('fa-minus').addClass('fa-plus');
            }
        });
    }, 100);

    // horziontal scroll
    // jQuery(".table-responsive , .thScroll, .tdScroll, .CustomModal .table-responsive").on("wheel", function(event) {
    //     // console.log(event);
    //     event.preventDefault();
    //     var isScrollableHorizontally = jQuery(this)[0].scrollWidth > jQuery(this)[0].clientWidth;
    //     if(isScrollableHorizontally){
    //         jQuery(this).scrollLeft($(this).scrollLeft() + event.originalEvent.deltaY);
    //     }
    // });

    // Select2 Without Search Bar

    $(".select2withoutsearch").select2({
        minimumResultsForSearch: Infinity
    }).next('.select2-container').addClass('withoutsearch');  // Add class to the selection box



    /** New Global JS */

    $(document).on('submit', '.form-save', function (e) {
        e.preventDefault();

        let url = $(this).attr('action');
        $.ajax({
            type: 'POST',
            url: url,
            data: new FormData(this),
            contentType: false,
            cache: false,
            processData: false,
            beforeSend: function () {
                removeFormValidationStyles();
                addFormLoadingStyles();
            },
            success: function (response) {
                printServerSuccessMessage(response);
            },
            error: function (response) {
                printServerValidationErrors(response);
            },
            complete: function () {
                removeFormLoadingStyles();
            }
        });
    })

    /** End New Quotation JS */



});
